// extracted by mini-css-extract-plugin
export default {"context-menu-item-view":"ContextMenuItemView_context-menu-item-view__iqwWF","icon-wrapper":"ContextMenuItemView_icon-wrapper__hmwZw","title":"ContextMenuItemView_title__5gxNd"};